import produce, { castDraft, } from 'immer';
import { DeviceKVStoresActionType, } from './actions';
const kvStoresByDeviceIdByKeyReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case DeviceKVStoresActionType.SET_DEVICE_KV_STORES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.deviceId] || {};
                draft[actualAction.deviceId] = temp;
                actualAction.kvStores.forEach((kvStore) => {
                    temp[kvStore.key] = kvStore;
                });
            });
        case DeviceKVStoresActionType.SET_DEVICE_KV_STORE:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.deviceId] || {};
                draft[actualAction.deviceId] = temp;
                temp[actualAction.kvStore.key] = actualAction.kvStore;
            });
        case DeviceKVStoresActionType.REMOVE_DEVICE_KV_STORE:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.deviceId] || {};
                delete temp[actualAction.key];
            });
        default:
            return currentState;
    }
};
const kvStoreKeysByDeviceIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case DeviceKVStoresActionType.SET_DEVICE_KV_STORES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.deviceId] || {};
                draft[actualAction.deviceId] = temp;
                // get the list of the keys from the actualAction.kvStores and save them
                temp[actualAction.searchParams] = actualAction.kvStores.map((kvStore) => {
                    return kvStore.key;
                });
            });
        case DeviceKVStoresActionType.CLEAR_DEVICE_KV_STORES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                delete draft[actualAction.deviceId];
            });
        default:
            return currentState;
    }
};
export const deviceKVStoresStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.kvStoresByDeviceIdByKey = kvStoresByDeviceIdByKeyReducer(currentState.kvStoresByDeviceIdByKey, action);
        draft.kvStoreKeysByDeviceId = castDraft(kvStoreKeysByDeviceIdReducer(currentState.kvStoreKeysByDeviceId, action));
    });
};
